import React, { useEffect, useState, FC } from 'react';

import useMediaQuery from '@mui/material/useMediaQuery';

import { Bar } from 'react-chartjs-2';

import { SaleCasesMonthlyCountsType } from '@type-def_iqfu/DashboardType';

import { DeskTopMediaQuery } from '@constants_iqfu';

import styles from './SaleCasesMonthlyCounts.module.scss';

type Props = {
  saleCasesMonthlyCounts: SaleCasesMonthlyCountsType[];
};

const SaleCasesMonthlyCounts: FC<Props> = ({ saleCasesMonthlyCounts }) => {
  const isDesktop = useMediaQuery(DeskTopMediaQuery);
  const [labels, setLabels] = useState<string[]>([]);
  const [mansionDatasets, setMansionDatasets] = useState<number[]>([]);
  const [landDatasets, setLandDatasets] = useState<number[]>([]);
  const [usedHouseDatasets, setUsedHouseDatasets] = useState<number[]>([]);
  const [newHouseDatasets, setNewHouseDatasets] = useState<number[]>([]);
  const [mobileMonth, setMobileMonth] = useState<string[]>([]);
  const [desktopMonth, setDesktopMonth] = useState<string[]>([]);
  const [fetchComplete, setFetchComplete] = useState(false);

  useEffect(() => {
    if (isDesktop) {
      setLabels(desktopMonth);
    } else {
      setLabels(mobileMonth);
    }
  }, [fetchComplete, isDesktop]);

  useEffect(() => {
    fetchCounts();
  }, [saleCasesMonthlyCounts]);

  const fetchCounts = async (): Promise<void> => {
    if (saleCasesMonthlyCounts && saleCasesMonthlyCounts.length > 1) {
      const mobileMonthArray: string[] = [];
      const desktopMonthArray: string[] = [];
      const mansionArray: number[] = [];
      const landArray: number[] = [];
      const newHouseArray: number[] = [];
      const usedHOuseArray: number[] = [];
      saleCasesMonthlyCounts.map((data) => {
        let desktopMonth = data.month.slice(0, 4) + '年' + Number(data.month.slice(5, 7)) + '月';
        let mobileMonth = Number(data.month.slice(5, 7)) + '月';
        mobileMonthArray.push(mobileMonth);
        desktopMonthArray.push(desktopMonth);
        mansionArray.push(data.mansion_count);
        landArray.push(data.land_count);
        newHouseArray.push(data.new_house_count);
        usedHOuseArray.push(data.used_house_count);
      });

      setMobileMonth(mobileMonthArray);
      setDesktopMonth(desktopMonthArray);
      setMansionDatasets(mansionArray);
      setLandDatasets(landArray);
      setNewHouseDatasets(newHouseArray);
      setUsedHouseDatasets(usedHOuseArray);
      setFetchComplete(true);
    }
  };

  const graphData = {
    labels,
    datasets: [
      {
        label: 'マンション',
        data: mansionDatasets,
        backgroundColor: '#3b83c3',
        stack: 'stack',
      },
      {
        label: '中古戸建',
        data: usedHouseDatasets,
        backgroundColor: '#d62c45',
        stack: 'stack',
      },
      {
        label: '新築戸建',
        data: newHouseDatasets,
        backgroundColor: '#4aa54d',
        stack: 'stack',
      },
      {
        label: '土地',
        data: landDatasets,
        backgroundColor: '#ffa907',
        stack: 'stack',
      },
    ],
  };

  const graphOptions = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  return (
    <>
      {labels.length > 0 ? (
        <div className={styles.container}>
          <Bar data={graphData} options={graphOptions} />
        </div>
      ) : (
        <p></p>
      )}
    </>
  );
};

export default SaleCasesMonthlyCounts;
